export const FETCH_MOBILE_SETTINGS_REQUEST =
  'mobileSettings/FETCH_MOBILE_SETTINGS_REQUEST'
export const FETCH_MOBILE_SETTINGS_SUCCESS =
  'mobileSettings/FETCH_MOBILE_SETTINGS_SUCCESS'
export const FETCH_MOBILE_SETTINGS_FAILURE =
  'mobileSettings/FETCH_MOBILE_SETTINGS_FAILURE'

export const UPDATE_MOBILE_SETTINGS_REQUEST =
  'mobileSettings/UPDATE_MOBILE_SETTINGS_REQUEST'
export const UPDATE_MOBILE_SETTINGS_SUCCESS =
  'mobileSettings/UPDATE_MOBILE_SETTINGS_SUCCESS'
export const UPDATE_MOBILE_SETTINGS_FAILURE =
  'mobileSettings/UPDATE_MOBILE_SETTINGS_FAILURE'

export const UPDATE_FIELD = 'mobileSettings/UPDATE_FIELD'
export const SET_DEFAULT_DATA = 'mobileSettings/SET_DEFAULT_DATA'
